<template>
    <div>
		<el-row :gutter="10" class="mb8">
			<el-col :span="1.5">
				<el-button type="primary" icon="el-icon-plus" @click="handleAdd()" v-permission="'AGENT_COST_TEMPLATE_QUERY'">新增返现配置</el-button>
			</el-col>
		</el-row>

		<CustomForm :on-fresh="showCustomForm" @on-close="handlerCustomFormOnclose" :isAdd="isAdd"></CustomForm>
	</div>
</template>

<script>
	import CustomForm from "./CustomForm";
    export default {
        name: "ToolBar",
		components: {CustomForm},
		props: {
			dicts: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {
				showCustomForm: false,
				isAdd: true
			}
		},
		mounted() {
		},
		methods: {
			handlerCustomFormOnclose() {
				this.showCustomForm = false;
				this.commitChange();
			},
			handleAdd(){
				this.showCustomForm = true;
			},
			commitChange() {
				this.$emit('on-change');
			},
		}
    }
</script>

<style scoped>

</style>
